const AVERAGE_REVIEW_SCORE_DIVIDER = 2;
const AVERAGE_REVIEW_SCORE_PRECISION = 2;
export default function average(input: string | number | null | undefined): number {
  const number = Number(input);
  return Number.isNaN(number)
    ? 0
    : Number((number / AVERAGE_REVIEW_SCORE_DIVIDER).toFixed(AVERAGE_REVIEW_SCORE_PRECISION));
}
